import ContinueButton from "@/shared-components/buttons/components/ContinueButton";
import BackArrowIcon from "@/shared-components/icons/components/public/BackArrowIcon";
import XIcon from "@/shared-components/icons/components/public/XIcon";
import GenericPopup from "@/shared-components/popups/components/GenericPopup";

import {
  TEMPLATE_DESIGNS,
  TEMPLATE_FORMATS,
  TEMPLATE_MODE_PALETTE,
} from "../constants";

import TemplatePreview from "./TemplatePreview";

import "./styles/PopupSelectDesign.css";

const DESIGN_OPTIONS = [
  {
    id: TEMPLATE_DESIGNS.TYPE_ONE,
    label: "Type I",
    description: "Text header with immersive cropped artwork",
    requiresCrop: true,
  },
  {
    id: TEMPLATE_DESIGNS.TYPE_TWO,
    label: "Type II",
    description: "Blurred backdrop with centered full artwork",
  },
  {
    id: TEMPLATE_DESIGNS.TYPE_THREE,
    label: "Type III",
    description: "Minimal single artwork on solid background",
  },
];

const DEFAULT_FORMAT = TEMPLATE_FORMATS.STORY;

const PreviewSwatch = ({ designId, mode, image, format }) => {
  const palette = TEMPLATE_MODE_PALETTE[mode] || TEMPLATE_MODE_PALETTE.dark;
  const safeFormat = format || DEFAULT_FORMAT;
  const previewImage = image || "";

  return (
    <div
      className="design-option__preview"
      data-mode={mode}
      data-format={safeFormat}
      style={{ "--preview-background": palette.background }}
    >
      <div className="design-option__preview-inner">
        <TemplatePreview
          croppedUrl={previewImage}
          design={designId}
          format={safeFormat}
          mode={mode}
          originalImage={previewImage}
        />
      </div>
    </div>
  );
};

const DesignOption = ({
  design,
  isActive,
  onSelect,
  mode,
  image,
  format,
}) => (
  <button
    type="button"
    className={`design-option ${isActive ? "active" : ""}`}
    onClick={() => onSelect(design.id)}
  >
    <PreviewSwatch
      designId={design.id}
      mode={mode}
      image={image}
      format={format}
    />
    <div className="design-option__copy">
      <span>{design.label}</span>
      <p>{design.description}</p>
    </div>
  </button>
);

const PopupSelectDesign = ({
  open,
  onClose,
  onGoBack,
  mode,
  format,
  selectedDesign,
  onSelectDesign,
  onContinue,
  image,
}) => {
  const isContinueDisabled = !selectedDesign;
  const previewFormat = format || DEFAULT_FORMAT;
  const continueLabel =
    selectedDesign === TEMPLATE_DESIGNS.TYPE_ONE ? "Continue" : "Preview";
  const handleGoBack = onGoBack || onClose;
  const stopPropagation = (event) => event.stopPropagation();

  return (
    <GenericPopup
      open={open}
      className="artwork-options__download-template-container design-step__container"
      opacity
      onTouchStart={stopPropagation}
      onTouchEnd={stopPropagation}
      onWheel={stopPropagation}
    >
      <div className="design-step__header">
        <BackArrowIcon
          className="artwork-options__download-template_header-back"
          onClick={handleGoBack}
        />
        <p className="artwork-options__download-template_header-text">
          Generate template
        </p>
        <XIcon
          className="artwork-options__download-template_header-close"
          onClick={onClose}
        />
        <p className="artwork-options__download-template_header-step-text">
          <span className="artwork-options__download-template_header-step-text-span">
            2.
          </span>
          Pick the desired template design
        </p>
      </div>

      <div className="design-step__list">
        {DESIGN_OPTIONS.map((design) => (
          <DesignOption
            key={design.id}
            design={design}
            isActive={selectedDesign === design.id}
            onSelect={onSelectDesign}
            mode={mode}
            image={image}
            format={previewFormat}
          />
        ))}
      </div>

      <ContinueButton
        className={`design-step__cta ${isContinueDisabled ? "" : "active"}`}
        onClick={onContinue}
        turnOff={isContinueDisabled}
      >
        {continueLabel}
      </ContinueButton>
    </GenericPopup>
  );
};

export default PopupSelectDesign;
